//loader.interceptor.ts

import { Component, OnInit } from "@angular/core";

import { LoaderService } from "./loader.service";
import {
  NavigationEnd,
  Router,
  NavigationStart,
  NavigationCancel,
  NavigationError,
  Event,
} from "@angular/router";

@Component({
  selector: "app-loading",
  template: `
    <main [hidden]="!loading">
      <th-spinner
        [attr.s-img]="
          isAdmin
            ? './assets/images/mcLoader.svg'
            : './assets/images/loader.svg'
        "
      ></th-spinner>
    </main>
  `,
})
export class LoaderComponent implements OnInit {
  loading: boolean;
  hide = false;
  isAdmin = false;  
  constructor(private loaderService: LoaderService, private router: Router) {
    this.loaderService.loaderData.subscribe((r) => {
      this.isAdmin = r.isAdmin || this.isAdminPath();
      this.loading = r.loading;
    });

    this.router.events.subscribe((item: Event) => {
      if (item instanceof NavigationStart) {
        this.loading = true;
      }

      if (
        item instanceof NavigationEnd ||
        item instanceof NavigationError ||
        item instanceof NavigationCancel
      ) {
        this.loading = false;
      }
    });
  }

  ngOnInit() {
    this.hidespinner();
  }
  isAdminPath(): boolean {
    const urlPath = window.location.pathname;
    if (urlPath.toLowerCase().includes("/admin")) {
      return true;
    } else {
      return false;
    }
  }
  hidespinner() {
    setTimeout(() => {
      this.hide = true;
    }, 2000);
  }
}
